import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Portal } from '..';
import { classNames } from '../../utils';
import styles from './PortalMenu.module.css';
const PortalMenu = ({ id, buttonClassName, buttonStyle, buttonContent, listClassName, children, alignItemsRight, disabled = false, }) => {
    const menuButtonRef = useRef(null);
    const menuListRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [menuButtonRefDimensions, setMenuButtonRefDimensions] = useState({
        top: 0,
        left: 0,
        width: 0,
        height: 0,
    });
    const top = `${(menuButtonRefDimensions === null || menuButtonRefDimensions === void 0 ? void 0 : menuButtonRefDimensions.top) + (menuButtonRefDimensions === null || menuButtonRefDimensions === void 0 ? void 0 : menuButtonRefDimensions.height)}px`;
    const left = alignItemsRight
        ? undefined
        : `${menuButtonRefDimensions === null || menuButtonRefDimensions === void 0 ? void 0 : menuButtonRefDimensions.left}px`;
    const right = alignItemsRight
        ? `${window.innerWidth -
            (menuButtonRefDimensions === null || menuButtonRefDimensions === void 0 ? void 0 : menuButtonRefDimensions.left) -
            (menuButtonRefDimensions === null || menuButtonRefDimensions === void 0 ? void 0 : menuButtonRefDimensions.width)}px`
        : undefined;
    const handleClickOutside = useCallback((event) => {
        if (!menuButtonRef.current || !menuListRef.current) {
            return;
        }
        if (menuButtonRef.current.contains(event.target) === false &&
            menuListRef.current.contains(event.target) === false) {
            setIsOpen(false);
        }
    }, [menuButtonRef, menuListRef]);
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    let rafId;
    const updateButtonRefDimensions = () => {
        var _a;
        if (!isOpen) {
            return;
        }
        setMenuButtonRefDimensions(((_a = menuButtonRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || {
            top: 0,
            left: 0,
            width: 0,
            height: 0,
        });
        rafId = requestAnimationFrame(updateButtonRefDimensions);
    };
    useEffect(() => {
        if (isOpen) {
            rafId = requestAnimationFrame(updateButtonRefDimensions);
        }
        else {
            cancelAnimationFrame(rafId);
        }
        return () => cancelAnimationFrame(rafId);
    }, [isOpen]);
    return (_jsxs("div", { children: [_jsx("div", Object.assign({ id: id, ref: menuButtonRef, className: buttonClassName, style: buttonStyle, onClick: () => !disabled && setIsOpen(!isOpen) }, { children: typeof buttonContent === 'function'
                    ? buttonContent(isOpen)
                    : buttonContent }), void 0), isOpen && (_jsx(Portal, Object.assign({ id: "portalMenu" }, { children: _jsx("div", Object.assign({ ref: menuListRef, className: classNames(styles.list, listClassName), style: { top, left, right } }, { children: children && recursivelyAttachCloseFn(children, setIsOpen) }), void 0) }), void 0))] }, void 0));
};
const recursivelyAttachCloseFn = (children, setIsOpen) => {
    return React.Children.map(children, (child) => {
        var _a;
        if (!React.isValidElement(child)) {
            return child;
        }
        if (Array.isArray((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.children)) {
            return React.cloneElement(child, {
                children: recursivelyAttachCloseFn(child.props.children, setIsOpen),
            });
        }
        return React.cloneElement(child, { close: () => setIsOpen(false) });
    });
};
export default PortalMenu;
